<template>
  <div class="select">
    <InputWrapper :label="label">
      <vSelect
        :clearable="false"
        :label="identifier"
        :placeholder="placeholder"
        v-model="value"
        :options="options"
        class="select__v-select"
        :class="{ '-error': error }"
        :searchable="searchable"
      />
    </InputWrapper>
  </div>
</template>

<script>
import "vue-select/dist/vue-select.css";
import vSelect from "vue-select";
import InputWrapper from "./InputWrapper";

export default {
  name: "Select",
  components: {
    vSelect,
    InputWrapper
  },
  data() {
    return {
      value: this.initial
    };
  },
  props: {
    label: {
      type: String,
      default: undefined,
      required: false
    },
    placeholder: {
      type: String,
      default: undefined,
      required: false
    },
    options: {
      type: Array
    },
    identifier: {
      type: String,
      required: false
    },
    initial: {
      type: [Object, String],
      required: false
    },
    searchable: {
      type: Boolean,
      default: true
    },
    error: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value: function(val) {
      this.$emit("value", val[this.identifier]);
    }
  },
  mounted() {
    if (this.initial) {
      this.$emit("value", this.initial[this.identifier]);
    }
  }
};
</script>

<style lang="scss">
.select {
  display: block;

  &__v-select {
    $_v-select: &;
    border-radius: sizes("border-radius");
    max-width: 100%;
    transition: cta-transition(box-shadow);

    .vs__dropdown-toggle {
      background-color: theme-color("body");
      border-radius: sizes("border-radius");
      border: 0;
      box-shadow: theme-color("shadow");
      font-family: $font-family;
      font-size: px-to-rem(16px);
      overflow: hidden;
      padding: 14px 18px;
      width: 100%;
    }

    .vs__selected-options {
      height: 31px;
      margin: 0;
      max-width: 100%;
      min-width: 1px;
      padding: 0;
      width: 100%;
    }

    .vs__search {
      font-family: $font-family;
      font-size: px-to-rem(16px);
      margin: 0;
      padding: 0;

      @include if-tablet {
        font-size: px-to-rem(18px);
      }

      &::placeholder {
        color: theme-color("inactive");
      }
    }

    .vs__selected {
      font-size: px-to-rem(16px);
      margin: 0;
      padding: 0;
      white-space: nowrap;

      @include if-tablet {
        font-size: px-to-rem(18px);
      }
    }

    .vs__dropdown-menu {
      max-height: 200px;
    }

    .vs__actions {
      background-color: rgba(theme-color("body"), 0.8);
      display: block;
    }

    .vs__dropdown-option {
      font-size: px-to-rem(16px);
      padding: spacer("s");

      &--highlight {
        background: theme-color("accent-3");
      }
    }

    &.-error {
      box-shadow: theme-color("shadow-error");
    }
  }
}
</style>
